import { StockCard } from './IStockCard'

export interface IPremixRequest {
  premixRequestId: string
  premixRequestDisplayId: string
  premixId?: string
  inOutDirection: string
  sourceOrDestination: string
  stockCard: StockCard | null
  notes: string
  batches: IPremixRequestBatch[]
  createdAt: Date | null
}

export class PremixRequest {
  premixRequestId: string
  premixRequestDisplayId: string
  premixId?: string
  inOutDirection: string
  sourceOrDestination: string
  stockCard: StockCard | null
  notes: string
  batches: IPremixRequestBatch[]
  createdAt: Date | null
  constructor({
    premixRequestId,
    premixRequestDisplayId,
    premixId,
    inOutDirection,
    stockCard,
    sourceOrDestination,
    notes,
    batches,
    createdAt,
  }: Partial<IPremixRequest> = {}) {
    this.premixRequestId = premixRequestId ?? ''
    this.premixRequestDisplayId = premixRequestDisplayId ?? ''
    this.premixId = premixId
    this.inOutDirection = inOutDirection ?? ''
    this.stockCard = stockCard ?? null
    this.sourceOrDestination = sourceOrDestination ?? ''
    this.notes = notes ?? ''
    this.batches = batches ?? []
    this.createdAt = createdAt ?? null
  }
}

export interface IPremixRequestBatch {
  premixRequestId: string
  qtyRequested: number | null
  batchNumber: string
  createdAt: Date | null
}

export class PremixRequestBatch {
  premixRequestId: string
  qtyRequested: number | null
  batchNumber: string
  createdAt: Date | null
  constructor({
    premixRequestId,
    qtyRequested,
    batchNumber,
    createdAt,
  }: Partial<IPremixRequestBatch> = {}) {
    this.premixRequestId = premixRequestId ?? ''
    this.qtyRequested = qtyRequested ?? null
    this.batchNumber = batchNumber ?? ''
    this.createdAt = createdAt ?? null
  }
}

export enum PremixRequestSourceOrDestination {
  rnd = 'RnD',
  adjustment = 'Adjustment',
  adjustmentDamaged = 'Adjustment: Barang rusak',
  return = 'customer return',
  inNoCost = 'in no cost',
  stokQc = 'stok qc',
  outNoCost = 'out no cost',
  fillingAdditional = 'filling additional',
  productionReturnPremix = 'productionReturnPremix',
  productionAdditionalRequest = 'productionAdditionalRequest',
  production = 'production',
}
